<template>
  <div id="app" class="app-main">
	
		<!-- <div data-v-5209ba05="" class="el-backtop" style="right: 40px; bottom: 40px;"><i class="el-icon-caret-top"></i></div> -->
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->

    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/> -->

    <router-view />
  </div>
</template>
<script>
export default{
  data() {
    return{

    }
  },
  created() {
   
  },
  watch: {
    $route:function(){
      // 滚动区域并不是document的scrollTop为0,滚动区域为 class=page
      if (!document.getElementsByClassName('page') || !document.getElementsByClassName('page').length) {
        return
      }
      document.getElementsByClassName('page')[0].scrollTop = 0
    }
  },
  mounted() {
    // 根据不同路由跳转不同页面
    if (this._isMobile()) {
      console.log('手机端')
      // this.$router.replace('/mb_index')
      // window.open('', '_blank')
	   location.href = 'https://mp.weixin.qq.com/s?__biz=MzkwNDU2OTk4NA==&mid=2247483654&idx=1&sn=7ebc154020e0204055dbc9cc8beab2db&chksm=c085b4e9f7f23dff30d0e00f8b983486b702dcfccd00e7099e4315e899f190ddab1642d4235b#rd' 
	   
	  
    } else {
      console.log('pc端',sessionStorage.getItem('activeIndex'))
      // this.$router.replace('/home')
      if(sessionStorage.getItem('activeIndex') < 8 && this.$route.path == '/home'){
        this.$router.push({
          path: '/home',
        }, () => {})
      }
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },

    
  }

}
</script>
<style lang="scss">
// @import "~@/styles/common.scss";
// @import "~@/styles/index.scss";

 /*引入阿里字体图标*/
 @import './assets/iconfont/iconfont.css';


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased; // MacOS字体的抗锯齿
  -moz-osx-font-smoothing: grayscale; // 设置字体的抗锯齿或者光滑度
  word-break: break-all;
  // overflow: scroll;
  // -webkit-overflow-scrolling: touch;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

// *******************页面滚动条设置*****************
// 滚动条的宽度-滚动条整体部分
::-webkit-scrollbar {
  width: 3px; // 纵向
  height: 4px; // 横向
  background-color: #FCFCFC;
}
// 滚动条的滑块
::-webkit-scrollbar-thumb {
  // box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: rgb(65,190,255, 0.57);
  border-radius: 2px;
}

// 滚动条的轨道
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background-color: #EEEEEE;
}
</style>
